import React from "react";
import PropTypes from "prop-types";
import { observer } from "mobx-react";

import SubmenuButton from "../components/SubmenuButton";
import Counter from "../../Counter";

import sendMetric, { sendNavigationMetric } from "../../../utils/sendMetric";

import { useStore } from "../../../connect";

import { MAIN_PAGE_QUERY_PARAM_STRING } from "../../../consts";

import strings from "../../../locales/strings";

const OrderLink = ({
  // isTablet,
  color,
}) => {
  const { profile, baseUrl, header } = useStore();

  const isPrerender = process.env.PRERENDER === "1";
  const currentBaseUrl = isPrerender ? "SSI_PATH_TO_BASE_URL" : baseUrl;

  return profile.isLoggedIn ? (
    <SubmenuButton
      dropdownId="orders-submenu"
      dataName="orders-link"
      color={color}
      icon="ic_orders-out"
      // Счетчик дублируется в выпадашках в главном меню. Поэтому здесь он отключен
      // counter={
      //   !!profile.counters.orders && (
      //     <Counter maxValue={isTablet ? 9 : 99} active>
      //       {profile.counters.orders}
      //     </Counter>
      //   )
      // }
      dropdownItems={[
        {
          icon: "ic_orders-from-you-out",
          label: strings.ordersFromYou,
          href: `https://loads.${baseUrl}/orders/cargoOwner/Reconciliation?utm_source=header&utm_campaign=new_header`,
          counter: !!profile.counters.yourOrders && (
            <Counter maxValue={99} active>
              {profile.counters.yourOrders}
            </Counter>
          ),
          onClick: () => sendNavigationMetric("SUB_MENU_YOUR_ORDERS"),
        },
        {
          icon: "ic_orders-to-you-out",
          label: strings.ordersToYou,
          href: `https://loads.${baseUrl}/orders/carrier/Reconciliation?utm_source=header&utm_campaign=new_header`,
          counter: !!profile.counters.ordersToYou && (
            <Counter maxValue={99} active>
              {profile.counters.ordersToYou}
            </Counter>
          ),
          onClick: () => sendNavigationMetric("SUB_MENU_ORDERS_TO_YOU"),
        },
        {
          icon: "ic_add-circle-outline",
          label: strings.ordersToDriver,
          href: `https://loads.${baseUrl}/orders/application/create?utm_source=main_zakaz&utm_medium=click`,
          onClick: () => {
            sendMetric("ord-main-ordertodriver");
            sendNavigationMetric("SUB_MENU_ORDERS_TO_DRIVER");
          },
        },
      ]}
    >
      {strings.orders}
    </SubmenuButton>
  ) : (
    <SubmenuButton
      href={`https://${currentBaseUrl}/landings/udeal/?utm_source=header&utm_campaign=new_header${
        header.isMainPage ? `&${MAIN_PAGE_QUERY_PARAM_STRING}` : ""
      }`}
      dataName="orders-link"
      color={color}
      icon="ic_orders-out"
      onClick={() => sendNavigationMetric("SUB_MENU_ORDERS")}
    >
      {strings.orders}
    </SubmenuButton>
  );
};

OrderLink.propTypes = {
  // isTablet: PropTypes.bool,
  color: PropTypes.oneOf(["green", "yellow", "gray"]),
};

export default observer(OrderLink);
